"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Emails(_a) {
    var channel = _a.channel, voucher_id = _a.voucher_id;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1], closeModal = _b[2];
    var _c = ra_fetch_1.useApi('ecommerce').store('vouchers.emails', {
        id: voucher_id,
        emails: '',
        channel_id: channel.id,
    }), emails = _c[0], setEmails = _c[1], submitEmails = _c[2];
    function onSubmit() {
        submitEmails().then(function (response) {
            if (!response.errors.length) {
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: 'Ticket(s) verzonden', onClose: closeModal }); }
                });
            }
        });
    }
    return react_1.default.createElement(storybook_1.Layouts.Fullscreen, { className: 'flex items-center', returnUrl: '/vouchers' },
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'space-y-8' },
            react_1.default.createElement(storybook_1.Texts.Heading, { className: 'text-center font-bold' }, "Ticket versturen"),
            !emails.submitting && react_1.default.createElement(storybook_1.Vouchers.Report, { channel: channel, voucher_id: voucher_id, emails: emails }),
            react_1.default.createElement(storybook_1.Texts.Primary, { className: 'text-center' }, "Vul in het onderstaande textveld de ontvangers van het gratis ticket in. Je kan maximaal 250 ontvangers per keer invullen, zet ieder e-mailadres op een nieuwe regel en klik op versturen."),
            react_1.default.createElement(storybook_1.Forms.Textarea, { value: emails.data.emails, onChange: function (emails) { return setEmails({ emails: emails }); }, rows: 10, placeholder: 'naam@domain.nl\nnaam@domain.nl\nnaam@domain.nl\n...' }),
            react_1.default.createElement(storybook_1.Forms.Buttons, { submit: onSubmit, type: 'primary', className: 'w-full', loading: emails.submitting, title: 'Versturen' })));
}
exports.default = Emails;
